@use "@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss";

// Panel has no width prop or extraClasses seam for its body, so we reach the
// internal (scoped under our own `.panel`). Prefix match — Honeycomb versions the
// class name (`hcr-panel__body-16-3-0`).
.panel :global([class*="hcr-panel__body"]) {
  width: 30em;
  max-width: 100vw;
}

// PanelContent default side padding (24px) leaves only 332px for the tracker
// in the 380px panel body — too tight for three steps. Tightening to 12px
// gives the tracker 356px, enough for "Metadata / Subcategory / Dimension"
// at the small font size below. Shared by the wizard and the AI draft panel.
.panelContent.panelContent {
  max-width: 32em;
  padding-left: var(--hcr-spacing-2);
  padding-right: var(--hcr-spacing-2);
}
